export default __webpack_public_path__ + "static/media/image-fullBody-2000x3000-png.79b8c244.png";